module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "title": "Introduction"
    }
  }, [_c('div', {
    staticClass: "titlepage"
  }, [_c('div', [_c('div', [_c('h1', {
    staticClass: "title"
  }, [_c('a', {
    attrs: {
      "id": "d0e33",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Introduction ")])]), _c('a', {
    attrs: {
      "id": "d0e33",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e33",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e33",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })]), _c('a', {
    attrs: {
      "id": "d0e33",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("I believe to have a success with anything; you need to start with quality equipment and\n        ingredients. It is no different with Dutch oven cooking. I use Dutch ovens from Camp Chef\n        and Lodge because they are the best quality, and I prefer Kingsford charcoal to use for\n        cooking. As far as ingredients are concerned, use only high quality products for the best\n        results. ")])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e33",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e38",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Dutch ovens ")])]), _c('a', {
    attrs: {
      "id": "d0e38",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Most Dutch ovens come seasoned and ready for use. All you have to do is wash them. Over\n        time, with continued use, your oven will build up a better coating or season. Right after\n        cooking is the best time to clean your oven. I wash mine with water and a little soap, but\n        do not scrub the coating away or you will have to start over with the seasoning process.\n        Heat the Dutch oven in your house oven or over a camp stove or coals to get it completely\n        dry. Wipe it down with a little oil or cast iron conditioner. I use a conditioner sold by\n        Camp Chef that I really like. ")])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e38",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e42",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Heat ")])]), _c('a', {
    attrs: {
      "id": "d0e42",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Learning to control the heat is one of the trickiest parts about cooking in Dutch ovens,\n        but once you do, you will have great success. In this cookbook I have provided the number of\n        coals to use for each recipe. Always place the bottom coals in a ring shape underneath the\n        oven. The heat goes to the middle, so until you have some experience, don’t put coals in the\n        center of the ring. The top coals should be in an evenly spaced pattern around the lid of\n        the Dutch oven. A good rule of thumb for the amount of coals needed is to use twice the\n        number of coals as the oven is in inches—for instance, using a 12-inch oven, you need 12\n        coals for the top and 12 for the bottom, or 24. But you don’t put them on that way; you put\n        two-thirds of the 24 on the top, or 16, and one-third on the bottom, or 8. You may need to\n        tweak this formula as you become practiced, but it is a good starting point. For most\n        recipes, the baking temperature is about 350 degrees, and this formula achieves that\n        temperature. You can raise or lower the temperature by adding or removing 1 coal for\n        approximately every 20 degrees you need to adjust. ")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of dutch ovens."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Introduction",
      "src": "images/IMG_1366.jpg"
    }
  })])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e42",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "d0e51",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Tools ")])]), _c('a', {
    attrs: {
      "id": "d0e51",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("It is easy to spend a lot of money on tools for Dutch oven cooking. Before you go out and\n        buy a bunch of equipment, I recommend that you find someone who cooks with Dutch ovens and\n        ask about which tools they like. If you can attend a Dutch oven competition or gathering,\n        you can see many different tools and how they work. This way you won’t buy something that\n        isn’t going to work for you. It’s like test driving cars. Below is a list of items that will\n        get you started on your way to successful Dutch oven cooking. ")]), _vm._v(" "), _c('div', {
    staticClass: "itemizedlist"
  }, [_c('ul', {
    staticClass: "itemizedlist"
  }, [_c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Several good quality Dutch ovens—the 12-inch is the most popular and most recipes in\n              this book are geared for that size. It is useful to have a couple 12-inch ovens and\n              one or two that are smaller and larger. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Charcoal—plenty of it. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Lid lifters—there are many kinds, so find the one that works best for you. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Lid stands—very important for safety and cleanliness. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Heavy gloves—to keep your hands safe. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Tongs—for moving coals. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Charcoal starter—to get your coals heating up and ready to use. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Dutch oven table—this can go from reasonably priced to expensive, so find one you\n              like. I used a heavy baking sheet on two cinder blocks until I found the one I wanted.\n            ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Fold-up table—for your food preparation space. ")])]), _vm._v(" "), _c('li', {
    staticClass: "listitem"
  }, [_c('p', [_vm._v("Camp stove—this is a great way for starting coals and heating water. ")])])])])]), _c('h4', [_c('a', {
    attrs: {
      "id": "d0e51",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }), _c('a', {
    attrs: {
      "id": "pie",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_vm._v("Favorite tip ")])]), _c('a', {
    attrs: {
      "id": "pie",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  }, [_c('p', [_vm._v("Other than making sure to grease the oven prior to use, my favorite tip for Dutch oven\n        cooking is on how to remove a beautiful pie from the oven. Here is how you do it: ")]), _vm._v(" "), _c('p', [_vm._v("Place double layer strips of parchment paper across the bottom of the Dutch oven, extending\n        over the edges of the rim by a couple of inches, in an X pattern. Make your pie as directed\n        in the recipe, and when it is time to remove the pie from the oven, find a friend to help.\n        Each of you grab two legs of the X, and working together, carefully lift the pie out of the\n        oven and place on a serving platter or lid of the Dutch oven. After it has cooled a bit and\n        is stable, you can gently pull the parchment paper strips from under the pie. This works\n        like a charm!")]), _vm._v(" "), _c('div', {
    staticClass: "mediaobject",
    attrs: {
      "title": "Image of a pie."
    }
  }, [_c('img', {
    attrs: {
      "alt": "Introduction",
      "src": "images/IMG_1469.jpg"
    }
  })])])]), _c('a', {
    attrs: {
      "id": "pie",
      "xmlns:saxon": "http://icl.com/saxon"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-94b208a8","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ch01.vue
// module id = 72
// module chunks = 0